export enum CookWorkStatusReasoning {
    LOW_RATINGS = 'LOW_RATINGS',
    NON_RESPONSIVE = 'NON_RESPONSIVE',
    DENIES_WORK = 'DENIES_WORK',
    BEHAVIOUR_ISSUE = 'BEHAVIOUR_ISSUE',
    NOT_INTERESTED = 'NOT_INTERESTED',
    OCCUPIED = 'OCCUPIED',
    OUT_OF_CITY = 'OUT_OF_CITY',
    PRICING_ISSUE = 'PRICING_ISSUE',
    NOT_REACHABLE = 'NOT_REACHABLE',
    SERVICE_FAILURES = 'SERVICE_FAILURES',
    ZERO_TOLERANCE = 'ZERO_TOLERANCE',
    DISINTERMEDIATION = 'DISINTERMEDIATION',
}
